import { Injectable } from '@angular/core';
import { ApiService } from '@services/core-services/api.service';
import { Observable } from 'rxjs';
import { FilterEventSchema, FilterOption } from '@services/core-services/filters';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FilterOptionsService {
  constructor(private readonly api: ApiService) {}

  getFilterOptions(type: string): Observable<FilterOption> {
    return this.api
      .get<any>(`store/filter-options`, { listing_type: type })
      .pipe(map(({ content }: any) => content.filter_options));
  }

  getEventFilterPropertyDetails(id: string): Observable<FilterEventSchema> {
    return this.api
      .get<any>(`analytics/events/${id}`)
      .pipe(map(({ content }: any) => content.event_detail.schema));
  }
}
